export const apiKey = 'AIzaSyAqLMsS5QKyaavYDRjqnHwbOWde4M8yZyo';
export const autoCompleteURL =
  'https://maps.googleapis.com/maps/api/place/autocomplete/json';
